import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IListByLevelQueryPayload {
    query?: any
}

export interface IListByLevelPayload {
    categoryId: string
    level?: number
}

const initialState = {
    status: STATUS.IDLE,
    data: [],
    dataHistory: [],
    errors: null
}

const listByLevelSlice = createSlice({
    name: 'hub/source-categories/list-by-level',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IListByLevelQueryPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
            if (!state.dataHistory.find(item => item._id === action.payload._id)) {
                state.dataHistory.push(action.payload)
            }
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const listByLevelActions = listByLevelSlice.actions
export default listByLevelSlice.reducer
